module.exports = __webpack_public_path__ + "static/anisa-bf2a903754d12e1ac25d91e980236a70.png";